import * as actionTypes from "../ActionTypes";
import API from "../../network/redAPI";
import { BAGS_PAGE } from "../../constants/navigation";

import { getValue } from "../../helper/constant";
import { useParams } from "react-router";
import {FETCH_FILTERS_OPTION} from "../ActionTypes";

export const productCategory = (data, dispatch) => {
  API.Category(data)
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Product_Category,
          payload: data.data,
          refs: data.data.map((element, index) => {
            return element.cat_ref_id
          }),
          success: data.success,
        });
      } else {
        // alert(data.error)
      }
    });
};

export const productType = (dispatch) => {
  API.Type()
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Product_Type,
          payload: data.data,
        });
      } else {
        // alert(data.error)
      }
    });
};


export const ResetModalData = (data, dispatch) => {
  dispatch({
    type: actionTypes.ProductModal,
    payload: data.data,
    success: data.success,
  });
};

export const ProductModalData = (data, dispatch) => {
  API.GetProductByRefId(data)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success && data.data !== null) {
        dispatch({
          type: actionTypes.ProductModal,
          payload: data.data,
          success: data.success,
        });
      } else {
        dispatch({
          type: actionTypes.Product_Fetch,
          payload: false
        });
      }
    });
};

const getFilterBrands = (data) => {
  let brandArr = [];
  const getIdAndName = (value) => {
    if (
      value.brand_id &&
      value.name
    ) {
      return { value: value.brand_id, label: value.name,qty:value.qty,product_quantity:value?.product_quantity };
    }
    return null;
  };
  data &&
    data.length &&
    data.forEach((item, index) => {
      if (!brandArr.length) {
        let data = getIdAndName(item);
        if (data) {
          brandArr.push(data);
        }
      } else {
        const duplicate = brandArr.find(
          (brand) => brand.value === item.brand_id
        );
        if (!duplicate) {
          let data = getIdAndName(item);
          if (data) {
            brandArr.push(data);
          }
        }
      }
    });
  return brandArr;
};

const getFilterCategory = (data) => {
  let catArr = [];
  const getIdAndName = (value) => {
    if (
      value.cat_id &&
      value.name
    ) {
      return { value: value.cat_id, label: value.name,qty: value.qty };
    }
    return null;
  };
  data &&
    data.length &&
    data.forEach((item, index) => {
      if (!catArr.length) {
        let data = getIdAndName(item);
        if (data) {
          catArr.push(data);
        }
      } else {
        const duplicate = catArr.find(
          (cat) => cat.value === item.cat_id
        );
        if (!duplicate) {
          let data = getIdAndName(item);
          if (data) {
            catArr.push(data);
          }
        }
      }
    });
  return catArr;
};

const getFilterDietary = (data) => {
	let dietArr = [];
	const getIdAndName = (value) => {
		if (
			value.diet_id &&
			value.name
		) {
			return {value: value.diet_id, label: value.name, qty: value.qty};
		}
		return null;
	};
	data &&
	data.length &&
	data.forEach((item, index) => {
		if (!dietArr.length) {
			let data = getIdAndName(item);
			if (data) {
				dietArr.push(data);
			}
		} else {
			const duplicate = dietArr.find(
				(cat) => cat.value === item.diet_id
			);
			if (!duplicate) {
				let data = getIdAndName(item);
				if (data) {
					dietArr.push(data);
				}
			}
		}
	});
	return dietArr;
};

const getFilterSubCategory = (data) => {
  let subCatArr = [];
  const getIdAndName = (value) => {
    if (
      value.sub_cat_id &&
      value.name
    ) {
      return { value: value.sub_cat_id, label: value.name, qty: value.qty };
    }
    return null;
  };
  data &&
    data.length &&
    data.forEach((item, index) => {
      if (!subCatArr.length) {
        let data = getIdAndName(item);
        if (data) {
          subCatArr.push(data);
        }
      } else {
        const duplicate = subCatArr.find(
          (subCat) => subCat.value === item.sub_cat_id
        );
        if (!duplicate) {
          let data = getIdAndName(item);
          if (data) {
            subCatArr.push(data);
          }
        }
      }
    });
  return subCatArr;
};

const getFilterCountry = (data) => {
  let countryArr = [];

  if(data && data.length){
    countryArr = data.reduce((acc, curr) => {
      acc.push({
        value: curr.id,
        label: curr.name,
        code: curr.code
      });
      return acc;
    }, []);
  }
  
  return countryArr;
};

export const getProductsMappedwithCat = (body, dispatch) => {
  localStorage.setItem("mode","cat");
  dispatch({
    type: actionTypes.Loading_Enable,
  });
  let cid = 0;
  API.GetProductsMappedwithCat(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        // const pi = data.data.map((item, index) => {
        //   cid = item.cat_id;
        //   return {
        //     name: item.name,
        //     product_id: item.item_id,
        //     sku: item.product_code,
        //     price: item.store_items_price_types[0].price,
        //     category: item.cat_id,
        //     position: index + 1,
        //   };
        // });
        // Products Searched
        // window.analytics && window.analytics.track("Products Searched", {
        //   query:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        // });
        // Product List Viewed
        // window.analytics && window.analytics.track("Product List Viewed", {
        //   list_id: window.location.pathname === "/" ? 18 : cid,
        //   category:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        //   products: pi,
        // });
        dispatch({
          type: actionTypes.Filter_Brands,
          payload: {
            brand:getFilterBrands(data.brands),
            category:getFilterCategory(data.catData),
            sub_category: getFilterSubCategory(data.subCatData),
            countries: getFilterCountry(data.countryData),
            page: body.page,
            min: body.min,
            max: body.max,
            sort: body.sort,
            priority: body.priority,
            oos: body.oos,
            brand_id: body.brand_id,
            cat_id: body.cat_id,
            cat_id_18: body.cat_id_18, 
            sub_cat_id: body.sub_cat_id,
            sub_cat_18: body.sub_cat_18,
            country_id: body.country_id,
	          promotion: body.promotion,
	          diet_id: body.diet_id,
	          dietary: getFilterDietary(data.dietaryData),
          }
        });
        dispatch({
          type: actionTypes.Products_Mappedwith_Cat,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      } else {
        // alert(data.error);
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
};

export const getProductOutOfStockCat = (body, dispatch) => {
  localStorage.setItem("mode","catoos");
  body.oos = 1;
  dispatch({
    type: actionTypes.Loading_Enable,
  });
  API.GetAllProductMappedCatOutofStock(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        let cid = 0;
        //searchedproducts
        // const pi = data.data.map((item, index) => {
        //   cid = item.cat_id;
        //   return {
        //     name: item.name,
        //     product_id: item.item_id,
        //     sku: item.product_code,
        //     price: item.store_items_price_types[0].price,
        //     category: item.cat_id,
        //     position: index + 1,
        //   };
        // });
        // Products Searched
        // window.analytics && window.analytics.track("Products Searched", {
        //   query:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        // });
        // Product List Viewed
        // window.analytics && window.analytics.track("Product List Viewed", {
        //   list_id: window.location.pathname === "/" ? 18 : cid,
        //   category:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        //   products: pi,
        // });
        dispatch({
          type: actionTypes.Filter_Brands,
          payload: {
            brand: getFilterBrands(data.brands),
            category: getFilterCategory(data.catData),
            sub_category: getFilterSubCategory(data.subCatData),
            countries: getFilterCountry(data.countryData),
            page: body.page,
            min: body.min,
            max: body.max,
            sort: body.sort,
            priority: body.priority,
            oos: body.oos,
            brand_id: body.brand_id,
            cat_id: body.cat_id,
            cat_id_18: body.cat_id_18,
            sub_cat_id: body.sub_cat_id,
            sub_cat_18: body.sub_cat_18,
            country_id: body.country_id,
            promotion: body.promotion,
	          diet_id: body.diet_id,
	          dietary: getFilterDietary(data.dietaryData),
          }
        });
        dispatch({
          type: actionTypes.Products_Mappedwith_Cat_OutOfStock,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      } else {
        // alert(data.error);
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
};

export const getProductsMappedwithSubCat = (body, dispatch) => {
  localStorage.setItem("mode","subcat");
  if(body.sub_cat_id){
  dispatch({
    type: actionTypes.Loading_Enable,
  });
  let cid = 0;
  API.GetProductsMappedwithSubCat(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        // const pi = data.data.map((item, index) => {
        //   cid = item.cat_id;
        //   return {
        //     name: item.name,
        //     product_id: item.item_id,
        //     sku: item.product_code,
        //     price: item.store_items_price_types[0].price,
        //     category: item.cat_id,
        //     position: index + 1,
        //   };
        // });
        // Products Searched
        // window.analytics && window.analytics.track("Products Searched", {
        //   query:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        // });
        // Product List Viewed
        // window.analytics && window.analytics.track("Product List Viewed", {
        //   list_id: window.location.pathname === "/" ? 18 : cid,
        //   category:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        //   products: pi,
        // });

        dispatch({
          type: actionTypes.Filter_Brands,
          payload: {
            brand: getFilterBrands(data.brands),
            category: getFilterCategory(data.catData),
            sub_category: getFilterSubCategory(data.subCatData),
            countries: getFilterCountry(data.countryData),
            page: body.page,
            min: body.min,
            max: body.max,
            sort: body.sort,
            priority: body.priority,
            oos: body.oos,
            brand_id: body.brand_id,
            cat_id: body.cat_id,
            cat_id_18: body.cat_id,
            sub_cat_id: body.sub_cat_id,
            sub_cat_18: body.sub_cat_18,
            country_id: body.country_id,
            promotion: body.promotion,
	          diet_id: body.diet_id,
	          dietary: getFilterDietary(data.dietaryData),
          }
        });
        dispatch({
          type: actionTypes.Products_Mappedwith_SubCat,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      } else {
        // alert(data.error);
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
  }
  else{
    //
  }
};

export const searchSuggestions = async (body, dispatch) => {
  dispatch({
    type: actionTypes.SUGGESTION_LOADING,
    payload: true,
  });
  await API.SearchStoreProductWithCategoryV2(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.SUGGESTION_ITEM,
          items: data.data.items,
          list_brands: data.data.list_brands,
          list_categories: data.data.list_categories,
          list_subcategories: data.data.list_subcategories,
          success: data.success,
        });
        dispatch({
          type: actionTypes.SUGGESTION_LOADING,
          payload: false,
        });
      }
    });
};

export const searchStoreProduct = (body, dispatch) => {
  body.oos = 0;
  localStorage.setItem("mode","search");
  dispatch({
    type: actionTypes.Loading_Enable,
  });

  API.SearchStoreProductBySubCategory(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        let cid = 0;
        // window.analytics && window.analytics.track("Products Searched", {
        //   query:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[2],
        // });
        dispatch({
          type: actionTypes.Filter_Brands,
          payload: {
            brand: getFilterBrands(data.brands),
            category: getFilterCategory(data.catData),
            sub_category: getFilterSubCategory(data.subCatData),
            countries: getFilterCountry(data.countryData),
            page: body.page,
            min: body.min,
            max: body.max,
            sort: body.sort,
            priority: body.priority,
            oos: body.oos,
            brand_id: body.brand_id,
            cat_id: body.cat_id,
            cat_id_18: body.cat_id,
            sub_cat_id: body.sub_cat_id,
            sub_cat_18: body.sub_cat_18,
            country_id: body.country_id,
            promotion: body.promotion,
	          diet_id: body.diet_id,
	          dietary: getFilterDietary(data.dietaryData),
          }
        });
        dispatch({
          type: actionTypes.Search_Store_Product,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      } else {
        // alert(data.error);
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
};

export const getProductOutOfStock = (body, dispatch) => {
  localStorage.setItem("mode","subcatoos");
  // body.oos = 1;
  if(body.sub_cat_id){
  dispatch({
    type: actionTypes.Loading_Enable,
  });
  API.GetAllProductMappedSubCatOutofStock(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        let cid = 0;
        //searchedproducts
        // const pi = data.data.map((item, index) => {
        //   cid = item.cat_id;
        //   return {
        //     name: item.name,
        //     product_id: item.item_id,
        //     sku: item.product_code,
        //     price: item.store_items_price_types[0].price,
        //     category: item.cat_id,
        //     position: index + 1,
        //   };
        // });
        // Products Searched
        // window.analytics && window.analytics.track("Products Searched", {
        //   query:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        // });
        // Product List Viewed
        // window.analytics && window.analytics.track("Product List Viewed", {
        //   list_id: window.location.pathname === "/" ? 18 : cid,
        //   category:
        //     window.location.pathname === "/"
        //       ? "best-deals"
        //       : window.location.pathname.split("/")[1],
        //   products: pi,
        // });
        dispatch({
          type: actionTypes.Filter_Brands,
          payload: {
            brand: getFilterBrands(data.brands),
            category: getFilterCategory(data.catData),
            sub_category: getFilterSubCategory(data.subCatData),
            countries: getFilterCountry(data.countryData),
            page: body.page,
            min: body.min,
            max: body.max,
            sort: body.sort,
            priority: body.priority,
            oos: body.oos,
            brand_id: body.brand_id,
            cat_id: body.cat_id,
            cat_id_18: body.cat_id,
            sub_cat_id: body.sub_cat_id,
            sub_cat_18: body.sub_cat_18,
            country_id: body.country_id,
            promotion: body.promotion,
	          diet_id: body.diet_id,
	          dietary: getFilterDietary(data.dietaryData),
          }
        });
        dispatch({
          type: actionTypes.Out_Of_Stock,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      } else {
        // alert(data.error);
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
  }
  else{
    //
  }
};

export const SearchStoreProductByBrandRef = (body,dispatch) => {
  localStorage.setItem("mode","brand");
  dispatch({
    type: actionTypes.Loading_Enable,
  });
  API.searchStoreProductByBrandRef(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Filter_Brands,
          payload: {
              data:data.data,
              brand: getFilterBrands(data.brands),
              category: getFilterCategory(data.catData),
              sub_category: getFilterSubCategory(data.subCatData),
              countries: getFilterCountry(data.countryData),
              page: body.page,
              min: body.min,
              max: body.max,
              sort: body.sort,
              priority: body.priority,
              oos: body.oos,
              brand_id: body.brand_id,
              cat_id: body.cat_id,
              cat_id_18: body.cat_id,
              sub_cat_id: body.sub_cat_id,
              sub_cat_18: body.sub_cat_18,
              country_id: body.country_id,
              promotion: body.promotion,
	          diet_id: body.diet_id,
	          dietary: getFilterDietary(data.dietaryData),
            },
              success: data.success,
        });
        dispatch({
          type: actionTypes.Brand_Products,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      } else {
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
};

export const getProductBrands = async (dispatch) => {
  await API.GetProductBrands()
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Product_Brands,
          payload: data.data,
          success: data.success,
        });
      } else {
        // alert(data.error);
      }
    });
};

export const getBrandByName = (data, dispatch) => {
  dispatch({
    type: actionTypes.Brand_by_Name,
    payload: data,
    success: data.success,
  });
};

/**
 * Fetches brand data by slug and dispatches the result.
 *
 * @param {string} slug - The slug of the brand to fetch.
 * @param {function} dispatch - The dispatch function to send actions to the store.
 * @returns {Promise<Object>} The fetched brand data or an error object.
 */
export const getBrandBySlug = async (slug, dispatch) => {
  try {
    // Make an API call to fetch the brand data by slug
    const response = await API.GetBrandBySlug(slug);
    const data = await response.json();

    if (data.success) {
      // Dispatch the fetched brand data to the store
      dispatch({
        type: actionTypes.Brand_by_Slug,
        payload: data.data,
        success: data.success,
      });
      return data;
    } else {
      // Log an error if the fetch was unsuccessful
      console.error("Error fetching brand:", data.error);
      return { success: false, error: data.error };
    }
  } catch (error) {
    // Log any errors that occur during the API request
    console.error("API request failed:", error);
    return { success: false, error: error.message };
  }
};

export const getProductFilterBrands = (
  body,
  products,
  allproducts,
  sub_cat_id,
  cat_id,
  brandName,
  oos,
  text,
  dispatch,
  // cat_selected
) => {
  if (body) {
    let if_cat_id = localStorage.getItem('cat_id');
    let if_sub_cat = localStorage.getItem('sub_cat_id');
    // let brandName  = useParams();
    let b = body.brands.map((el) => {
      return el.value;
    });
    let c = body.category.map((el) => {
      return el.value;
    });

	  let diet = body?.dietary.map((dt) => {
		  return dt.value
	  });
    let subCat = body.sub_category.map((el) => {
      return el.value;
    });
    let brand = body.brands.map((el) => {
      return el.label
    });
    // localStorage.setItem("brandName", brandName);
    let Mode = localStorage.getItem('mode');
    body.brands.brand_id = b;
    body.category.cat_id = c;
	  body.dietary.diet_id = diet;
    let OOS_filter = body.check;
    body.sub_category.sub_cat_id = subCat;
    if (body.brands.length > 0 || body.category.length > 0 || body.min != 0) {
      
      dispatch({
        type: actionTypes.Loading_Enable,
      });
      if (!OOS_filter){
        if(window.location.pathname.split("/")[1] === "search" || Mode === "search"){
          API.SearchStoreProductBySubCategory({
            // sub_cat_id: sub_cat_id === "-1" ? "0" : sub_cat_id,
            search_query: text,
            store_id: 1,
            page: 1,
            brand_id: b.length > 0  ? b : 0,
            cat_id: c.length > 0 ? c : cat_id != null ? cat_id : 0,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
            country_id: body.country_id,
            priority: body.priority,
            sort: body.sort,
            min: Number(body.min),
            max: Number(body.max),
            oos: OOS_filter ? 1 : 0,
            isFilter:body.isFilter,
            promotion: body.promotion,
	          diet_id: diet,
          })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              let cid = 0;
              // Products Searched
              // window.analytics && window.analytics.track("Products Searched", {
              //   query:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              // });
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                  promotion: body.promotion,
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                }
              });
              dispatch({
                type: actionTypes.Search_Store_Product,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else if (window.location.pathname.split("/")[1] === "brand" || Mode === "brand") {
          localStorage.setItem("mode", "brand");
          dispatch({
            type: actionTypes.Loading_Enable,
          });
          API.searchStoreProductByBrandRef({
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
            brand_ref_id: brandName, 
            store_id: 1, 
            cat_id: c.length > 0 ? c : cat_id != null ? cat_id : 0,
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            sort: body.sort,
            isFilter:body.isFilter, 
            oos: OOS_filter ? 1 : 0,
            min: Number(body.min),
            max: Number(body.max)})
            .then((response) => response.json())
            .then(async (data) => {
              if (data.success) {
                dispatch({
                  type: actionTypes.Filter_Brands,
                  payload: {
                    brand: getFilterBrands(data.brands),
                    category: getFilterCategory(data.catData),
                    sub_category: getFilterSubCategory(data.subCatData),
                    countries: getFilterCountry(data.countryData),
                    page: 1,
                    min: body.min,
                    max: body.max,
                    sort: body.sort,
                    priority: body.priority,
                    oos: OOS_filter ? 1 : 0,
                    brand_id: b.length > 0  ? b : 0,
                    cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                    cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                    sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                    sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                    country_id: body.country_id,
                    promotion: body.promotion,
	                  diet_id: diet,
	                  dietary: getFilterDietary(data.dietaryData),
                  }
                });
                dispatch({
                  type: actionTypes.Brand_Products,
                  payload: data.data,
                  success: data.success,
                });
                dispatch({
                  type: actionTypes.Loading_Disable,
                });
              } else {
                dispatch({
                  type: actionTypes.Loading_Disable,
                });
              }
            });
        }
        else if(sub_cat_id === "0" || sub_cat_id === "-1"){
          localStorage.setItem("mode","catoos");
          API.GetAllProductMappedCatOutofStock({ 
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            isFilter: body.isFilter, 
            store_id: 1, 
            page: 1, 
            oos: OOS_filter ? 1 : 0, 
            brand_id: b.length > 0 ? b : 0, 
            cat_id: (c.length > 0 && if_cat_id == 18) ? 18 : cat_id != null ? Number(cat_id) : 0, 
            cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            sort: body.sort,
            min: Number(body.min), max:Number(body.max)})
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                }
              });
              dispatch({
                type: actionTypes.Products_Mappedwith_Cat_OutOfStock,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else{
          localStorage.setItem("mode","subcatoos");
          API.GetAllProductMappedSubCatOutofStock({
            isFilter: body.isFilter,
            // sub_cat_id: sub_cat_id,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            sort: body.sort,
            promotion: body.promotion,
	          diet_id: diet,
            store_id: 1, page: 1, oos: OOS_filter ? 1 : 0, brand_id: b.length > 0  ? b : 0, cat_id: c.length > 0 ? c : cat_id != null ? cat_id : 0, 
             min: Number(body.min),
            max: Number(body.max) })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                }
              });
              dispatch({
                type: actionTypes.Out_Of_Stock,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
      }
      else{
        if (window.location.pathname.split("/")[1] === "search" || Mode === "search"){
          API.SearchStoreProductBySubCategory({
            // sub_cat_id: sub_cat_id === "-1" ? "0" : sub_cat_id,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            search_query: text,
            store_id: 1,
            page: 1,
            oos: OOS_filter ? 1 : 0,
            brand_id: b.length > 0  ? b : 0,
            cat_id: c.length > 0 ? c : cat_id != null ? cat_id : 0,
            country_id: body.country_id,
            priority: body.priority,
            sort: body.sort,
            min: Number(body.min),
            max: Number(body.max),
            isFilter: body.isFilter,
            promotion: body.promotion,
	          diet_id: diet,
          })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("data response is ", data.data);
            if (data.success) {
              let cid = 0;
              //searchedproducts
              // const pi = data.data.map((item, index) => {
              //   cid = item.cat_id;
              //   return {
              //     name: item.name,
              //     product_id: item.item_id,
              //     sku: item.product_code,
              //     price: item.store_items_price_types[0].price,
              //     category: item.cat_id,
              //     position: index + 1,
              //   };
              // });
              // Products Searched
              // window.analytics && window.analytics.track("Products Searched", {
              //   query:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              // });
              // Product List Viewed
              // window.analytics.track("Product List Viewed", {
              //   list_id: window.location.pathname === "/" ? 18 : cid,
              //   category:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              //   products: pi,
              // });
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                  promotion: body.promotion,
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                }
              });
              dispatch({
                type: actionTypes.Search_Store_Product,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else if(sub_cat_id === "0" || sub_cat_id === "-1"){
          localStorage.setItem("mode","cat");
          API.GetProductsMappedwithCat({ 
            min: Number(body.min),
            max: Number(body.max),
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
            sort: body.sort,
	          diet_id: diet,
            isFilter: body.isFilter, oos: OOS_filter ? 1 : 0, cat_id: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0, store_id: 1, page: 1, brand_id: b.length > 0  ? b : 0 })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                }
              });
              dispatch({
                type: actionTypes.Products_Mappedwith_Cat,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else{
          localStorage.setItem("mode","subcat");
          API.GetProductsMappedwithSubCat({ 
            min: Number(body.min),
            max: Number(body.max),
            cat_id: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            sort: body.sort,
	          isFilter: body.isFilter,
	          oos: OOS_filter ? 1 : 0,
	          store_id: 1,
	          page: 1,
	          brand_id: b.length > 0 ? b : 0
          })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Products_Mappedwith_SubCat,
                payload: data.data,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
      }
    } 
 //================================================================   
    else if (body.length === 0) {
      dispatch({
        type: actionTypes.Loading_Enable,
      });
      if(!oos){
        if (window.location.pathname.split("/")[1] === "search"|| Mode === "search"){
          API.SearchStoreProductBySubCategory({
            isFilter: body.isFilter,
            // sub_cat_id: sub_cat_id === "-1" ? "0" : sub_cat_id,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            search_query: text,
            store_id: 1,
            oos: OOS_filter ? 1 : 0,
            page: 1,
            brand_id: 0,
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            sort: body.sort,
            cat_id: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0,
            // cat_id: c.length > 0 ? c : cat_id != null ? cat_id : 0,
            min: Number(body.min),
            max: Number(body.max)
          })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("data response is ", data.data);
            if (data.success) {
              let cid = 0;
              //searchedproducts
              // const pi = data.data.map((item, index) => {
              //   cid = item.cat_id;
              //   return {
              //     name: item.name,
              //     product_id: item.item_id,
              //     sku: item.product_code,
              //     price: item.store_items_price_types[0].price,
              //     category: item.cat_id,
              //     position: index + 1,
              //   };
              // });
              // Products Searched
              // window.analytics && window.analytics.track("Products Searched", {
              //   query:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              // });
              // Product List Viewed
              // window.analytics.track("Product List Viewed", {
              //   list_id: window.location.pathname === "/" ? 18 : cid,
              //   category:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              //   products: pi,
              // });
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                }
              });
              dispatch({
                type: actionTypes.Search_Store_Product,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else if (window.location.pathname.split("/")[1] === "brand") {
          localStorage.setItem("mode", "brand");
          localStorage.setItem("brandName", brandName);
          // alert("BrlocalStorage.setItem("mode", "brand");and")
          dispatch({
            type: actionTypes.Loading_Enable,
          });
          API.searchStoreProductByBrandRef({
            isFilter: body.isFilter,
            oos: OOS_filter ? 1 : 0,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
            sort: body.sort,
	          diet_id: diet,
            brand_ref_id: brandName, store_id: 1, cat_id: c.length > 0 ? c : cat_id != null ? cat_id : 0, min: Number(body.min),
            max: Number(body.max) })
            .then((response) => response.json())
            .then(async (data) => {
              if (data.success) {
                dispatch({
                  type: actionTypes.Filter_Brands,
                  payload: {
                    brand: getFilterBrands(data.brands),
                    category: getFilterCategory(data.catData),
                    sub_category: getFilterSubCategory(data.subCatData),
                    countries: getFilterCountry(data.countryData),
	                  diet_id: diet,
	                  dietary: getFilterDietary(data.dietaryData),
                    page: 1,
                    min: body.min,
                    max: body.max,
                    sort: body.sort,
                    priority: body.priority,
                    promotion: body.promotion,
                    oos: OOS_filter ? 1 : 0,
                    brand_id: b.length > 0  ? b : 0,
                    cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                    cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                    sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                    sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                    country_id: body.country_id,
                  }
                });
                dispatch({
                  type: actionTypes.Brand_Products,
                  payload: data.data,
                  success: data.success,
                });
                dispatch({
                  type: actionTypes.Loading_Disable,
                });
              } else {
                dispatch({
                  type: actionTypes.Loading_Disable,
                });
              }
            });
        }
        else if(sub_cat_id === "0" || sub_cat_id === "-1"){
          localStorage.setItem("mode","catoos");
          API.GetAllProductMappedCatOutofStock({
            // sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? sub_cat_id : 0,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
            sort: body.sort,
	          diet_id: diet,
            isFilter: body.isFilter, cat_id: Number(cat_id), store_id: 1, page: 1, oos: OOS_filter ? 1 : 0, brand_id: 0, min: Number(body.min),
            max: Number(body.max) })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                }
              });
              dispatch({
                type: actionTypes.Products_Mappedwith_Cat_OutOfStock,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else{
          localStorage.setItem("mode","subcatoos");
          API.GetAllProductMappedSubCatOutofStock({
            isFilter: body.isFilter, 
            // sub_cat_id: sub_cat_id,
            cat_id: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            store_id: 1, page: 1, 
            oos: OOS_filter ? 1 : 0,
            brand_id: 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
            sort: body.sort,
	          diet_id: diet,
            min: Number(body.min),
            max: Number(body.max) })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                }
              });
              dispatch({
                type: actionTypes.Out_Of_Stock,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable
              });
            }
          });
        }
      }
////
      else{
        if (window.location.pathname.split("/")[1] === "search" || Mode === "search"){
          API.SearchStoreProductBySubCategory({
            isFilter: body.isFilter,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            search_query: text,
            cat_id: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0,
            store_id: 1,
            page: 1,
            brand_id: 0,
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            sort: body.sort,
            oos: OOS_filter ? 1 : 0,
          })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("data response is ", data.data);
            if (data.success) {
              let cid = 0;
              //searchedproducts
              // const pi = data.data.map((item, index) => {
              //   cid = item.cat_id;
              //   return {
              //     name: item.name,
              //     product_id: item.item_id,
              //     sku: item.product_code,
              //     price: item.store_items_price_types[0].price,
              //     category: item.cat_id,
              //     position: index + 1,
              //   };
              // });
              // Products Searched
              // window.analytics && window.analytics.track("Products Searched", {
              //   query:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              // });
              // Product List Viewed
              // window.analytics.track("Product List Viewed", {
              //   list_id: window.location.pathname === "/" ? 18 : cid,
              //   category:
              //     window.location.pathname === "/"
              //       ? "best-deals"
              //       : window.location.pathname.split("/")[2],
              //   products: pi,
              // });
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                }
              });
              dispatch({
                type: actionTypes.Search_Store_Product,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else if(sub_cat_id === "0" || sub_cat_id === "-1"){
          localStorage.setItem("mode","cat");
          API.GetProductsMappedwithCat({
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            oos: OOS_filter ? 1 : 0,
            sort: body.sort,
            isFilter: body.isFilter, cat_id: cat_id, store_id: 1, page: 1, brand_id: 0, min: Number(body.min),
            max: Number(body.max)
})
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Filter_Brands,
                payload: {
                  brand: getFilterBrands(data.brands),
                  category: getFilterCategory(data.catData),
                  sub_category: getFilterSubCategory(data.subCatData),
                  countries: getFilterCountry(data.countryData),
	                diet_id: diet,
	                dietary: getFilterDietary(data.dietaryData),
                  page: 1,
                  min: body.min,
                  max: body.max,
                  sort: body.sort,
                  priority: body.priority,
                  promotion: body.promotion,
                  oos: OOS_filter ? 1 : 0,
                  brand_id: b.length > 0  ? b : 0,
                  cat_id:  c.length > 0 ? c : cat_id != null ? cat_id : 0,
                  cat_id_18: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0 , 
                  sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0,
                  country_id: body.country_id,
                }
              });
              dispatch({
                type: actionTypes.Products_Mappedwith_Cat,
                payload: data.data,
                success: data.success,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
        else{
          localStorage.setItem("mode","subcat");
          API.GetProductsMappedwithSubCat({
            isFilter: body.isFilter, 
            // sub_cat_id: sub_cat_id,
            cat_id: c.length > 0 ? c : cat_id != null ? Number(cat_id) : 0,
            sub_cat_id: subCat.length > 0 && if_sub_cat == 187 || if_sub_cat == 215 || if_sub_cat == 214 ? Number(if_sub_cat) : sub_cat_id != null ? Number(sub_cat_id) : 0,
            sub_cat_18: (subCat.length > 0 && if_sub_cat != 187 || if_sub_cat != 215 || if_sub_cat != 214) ? subCat : sub_cat_id != null ? Number(sub_cat_id) : 0, 
            country_id: body.country_id,
            priority: body.priority,
            promotion: body.promotion,
	          diet_id: diet,
            oos: OOS_filter ? 1 : 0,
            sort: body.sort,
             store_id: 1, page: 1, brand_id: 0, min: Number(body.min),
            max: Number(body.max) })
          .then((response) => response.json())
          .then(async (data) => {
            if (data.success) {
              dispatch({
                type: actionTypes.Products_Mappedwith_SubCat,
                payload: data.data,
              });
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            } else {
              // alert(data.error);
              dispatch({
                type: actionTypes.Loading_Disable,
              });
            }
          });
        }
      }
    }
  }
};

export const getPromotionProducts = (body, dispatch) => {
  dispatch({
    type: actionTypes.PLoading_Enable,
  });

	// Use new API with promotion=1 and limit=50
	const params = {
		store_id: body.store_id || 1,
		promotion: 1,
		limit: 50,
		page: 1,
	};

	API.getProducts(params)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Promotion_Products,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.PLoading_Disable,
        });
      } else {
	      dispatch({
		      type: actionTypes.PLoading_Disable,
	      });
      }
    })
		.catch((error) => {
			console.error('Error fetching promotion products:', error);
			dispatch({
				type: actionTypes.PLoading_Disable,
			});
    });
};

export const getArrivalProducts = (body, dispatch) => {
  dispatch({
    type: actionTypes.NLoading_Enable,
  });

	// Use new API with new_arrival=1 and limit=50
	const params = {
		store_id: body.store_id || 1,
		new_arrival: 1,
		limit: 50,
		page: 1,
	};

	API.getProducts(params)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Arrival_Products,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.NLoading_Disable,
        });
      } else {
	      dispatch({
		      type: actionTypes.NLoading_Disable,
	      });
      }
    })
		.catch((error) => {
			console.error('Error fetching new arrival products:', error);
			dispatch({
				type: actionTypes.NLoading_Disable,
			});
    });
};

export const getTrendingProducts = (body, dispatch) => {
  dispatch({
    type: actionTypes.TLoading_Enable,
  });

	// Use new API with trending=1 and limit=50
	const params = {
		store_id: body.store_id || 1,
		trending: 1,
		limit: 50,
		page: 1,
	};

	API.getProducts(params)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.Trending_Products,
          payload: data.data,
          success: data.success,
        });
        dispatch({
          type: actionTypes.TLoading_Disable,
        });
      } else {
	      dispatch({
		      type: actionTypes.TLoading_Disable,
	      });
      }
    })
		.catch((error) => {
			console.error('Error fetching trending products:', error);
			dispatch({
				type: actionTypes.TLoading_Disable,
			});
    });
};

export const getSortProductsName = (type, products, dispatch) => {
  if (type == 1) {
    let data = products.sort((a, b) => {
      var productA = a.name.toLowerCase(),
        productB = b.name.toLowerCase();
      if (productA > productB) {
        return 1;
      }

      if (productA < productB) {
        return -1;
      }
      return 0;
    });
    dispatch({
      type: actionTypes.Product_Sort_Name,
      payload: data,
    });
  } else if (type == 2) {
    let data = products.sort((a, b) => {
      var productA = a.name.toLowerCase(),
        productB = b.name.toLowerCase();
      if (productA < productB) {
        return 1;
      }

      if (productA > productB) {
        return -1;
      }
      return 0;
    });
    dispatch({
      type: actionTypes.Product_Sort_Name,
      payload: data,
    });
  }
};

export const getRelatedProducts = (body, dispatch) => {
  API.GetRelatedProduct(body)
    .then((response) => response.json())
    .then(async (data) => {
      if (data.success) { 
        dispatch({
          type: actionTypes.Products_Related,
          payload: data.data,
        });
      }
    })
}

export const sortByNameProduct = (text, products, dispatch) => {
  let data = products.filter(function (ele) {
    console.log("ele", ele.name.includes(text), text);
    return ele.name.toLowerCase().includes(text.toLowerCase());
  });
  dispatch({
    type: actionTypes.Filtered_Name_Products,
    payload: data,
  });
  if (text.length == 0) {
    dispatch({
      type: actionTypes.Show_Filtered_Name_Products,
      payload: false,
    });
  } else {
    dispatch({
      type: actionTypes.Show_Filtered_Name_Products,
      payload: true,
    });
  }
};

export const getSortProductsPrice = (type, products, dispatch) => {
  if (type == 3) {
    let data = products.sort((a, b) => {
      return (
        parseFloat(a.store_items_price_types[0].price) -
        parseFloat(b.store_items_price_types[0].price)
      );
    });
    dispatch({
      type: actionTypes.Product_Sort_Price,
      payload: data,
    });
  } else if (type == 4) {
    let data = products.sort((a, b) => {
      return (
        parseFloat(b.store_items_price_types[0].price) -
        parseFloat(a.store_items_price_types[0].price)
      );
    });
    dispatch({
      type: actionTypes.Product_Sort_Price,
      payload: data,
    });
  }
};

export const Reset_Suggestions = (dispatch) => {
  dispatch({
    type: actionTypes.Reset_Suggestions
  });
};

export const Toggle_Suggestions = (body,dispatch) => {
  dispatch({
    type: actionTypes.Toggle_Suggestions,
    payload: body.toggle
  });
};

export const changePage = (body, dispatch) => {
  dispatch({
    type: actionTypes.Change_Page,
    payload: body.page
  });
};

export const resetPage = (dispatch) => {
  dispatch({
    type: actionTypes.Reset_Page
  });
};

export const resetFilters = (dispatch) => {
  dispatch({
    type: actionTypes.Reset_Filter_Brands
  });
};

export const changeRelatedProductPage = (body, dispatch) => {
  dispatch({
    type: actionTypes.Products_Related_Change_Page,
    payload: body.page
  });
};

export const resetRelatedProductPage = (dispatch) => {
  dispatch({
    type: actionTypes.Products_Related_Reset_Page
  });
};

export const toggleCats = (body, dispatch) => {
  dispatch({
    type: actionTypes.Toggle_Categories,
    payload: body.toggle
  });
};

/*Delishop Express*/
export const initExpressStore = (data, dispatch) => {
  dispatch({
    type: actionTypes.Product_Brands,
    payload: data,
    success: data.success,
  });
};

export const initProductExpressStore = (data, dispatch) => {
  dispatch({
    type: actionTypes.Product_Filter_Brands,
    payload: data,
  });
};

export const initCategoryExpressStore = (data, dispatch) => {
  dispatch({
    type: actionTypes.Product_Category,
    payload: data.data,
    refs: data.data.map((element, index) => {
      return element.cat_ref_id
    }),
    success: data.success,
  });
};

export const initCategoryFilter = (data, dispatch) => {
  dispatch({
    type: actionTypes.Filter_Brands,
    payload: data
  });
};

export const sortProducts = (data, dispatch) => {
  dispatch({
    type: actionTypes.Filtered_Name_Products,
    payload: data,
  });
};

export const initProductBrand = (data, dispatch) => {
  dispatch({
    type: actionTypes.Product_Brands,
    payload: data,
  });
};

export const productSelection = async (slug,page,limit,qry, dispatch,) => {
    let b = qry?.brands?.map((el) => {
      return el?.value;
    });
    let c = qry?.category?.map((el) => {
      return el?.value;
    });
    let subCat = qry?.sub_category?.map((el) => {
      return el?.value;
    });

	let diet = qry?.dietary?.map((el) => {
		return el?.value;
	});

    qry.brands = b?.length > 0 && b[0] != undefined ? b : [];
    qry.category = c;
    qry.sub_category = subCat;
	qry.dietary = diet;

	dispatch({
		type: actionTypes.Loading_Enable,
	});

  let payload = {}; // Initialize an empty payload object

  // Use optional chaining and check for existence
  if (qry) {
    if (qry.min != undefined && qry.min != 0) {
      payload.min = qry.min;
    }

    if (qry.max != undefined && qry.max != 1000) {
      payload.max = qry.max;
    }

    if (qry.sort !== undefined && qry.sort != "") {
      payload.sort = qry.sort;
    }

    if (qry.priority !== undefined) {
      payload.priority = qry.priority;
    }

    if (qry.oos !== undefined) {
      payload.oos = qry.oos;
    }
    if (qry.promotion !== undefined) {
      payload.promotion = qry.promotion;
    }
    if (Array.isArray(qry.brand_id) && qry.brand_id.length > 0) {
      payload.brand_id = qry.brand_id;
    }

    if (Array.isArray(qry.cat_id) && qry.cat_id.length > 0) {
      payload.cat_id = qry.cat_id;
    }

    if (qry.sub_cat_id !== undefined) {
      payload.sub_cat_id = qry.sub_cat_id;
    }

    if (Array.isArray(qry.country_id) && qry.country_id.length > 0) {
      payload.country_id = qry.country_id;
    }
  }

  // Now you can safely use the payload object

  await API.getProductsSelection(slug,page,limit,payload)
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.PRODUCTS_SELECTION,
          allproducts: data.data.items,
          page: page,
        });
        dispatch({
          type: actionTypes.PRODUCTS_SELECTION_FILTER,
          payload: {
            brand: getFilterBrands(data.data.brands),
            category: getFilterCategory(data.data.categories),
            sub_category: getFilterSubCategory(data.data.subCategories),
            countries: getFilterCountry(data.data.countries),
	          dietary: getFilterDietary(data.data.dietary),
	          diet_id: diet,
	          page: page,
            min: 0,
            max: 1000,
            promotion: false,
            sort: "a-z",
            priority: "1",
            oos: 0,
            brand_id: b?.length > 0 && b[0] != undefined ? b : 0,
            cat_id: c?.length > 0 ? c : 0,
            sub_cat_id: subCat?.length > 0 ? subCat : Number(0),
            country_id: qry?.country_id,
          },
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
};

export const productSelectionFilter = async (slug,page,limit,qry, dispatch,) => {
    let b = qry?.brands?.map((el) => {
      return el?.value;
    });
    let c = qry?.category?.map((el) => {
      return el?.value;
    });
    let subCat = qry?.sub_category?.map((el) => {
      return el?.value;
    });

	let diet = qry?.dietary?.map((el) => {
		return el?.value;
	});

    qry.brands = b;
	qry.category = c;
	qry.dietary = diet;
    qry.sub_category = subCat;
	dispatch({
		type: actionTypes.Loading_Enable,
	});

  let payload = {}; // Initialize an empty payload object

  // Use optional chaining and check for existence
  if (qry) {
    if (qry.min != undefined && qry.min != 0) {
      payload.min = qry.min;
    }

    if (qry.max != undefined && qry.max != 1000) {
      payload.max = qry.max;
    }

    if (qry.sort !== undefined && qry.sort != "") {
      payload.sort = qry.sort;
    }

    if (qry.promotion !== undefined) {
      payload.promotion = qry.promotion;
    }

    if (qry.priority !== undefined) {
      payload.priority = qry.priority;
    }

    if (qry.oos !== undefined) {
      payload.oos = qry.oos;
    }

    if (Array.isArray(qry.brand_id) && qry.brand_id.length > 0) {
      payload.brand_id = qry.brand_id;
    }

    if (Array.isArray(qry.cat_id) && qry.cat_id.length > 0) {
      payload.cat_id = qry.cat_id;
    }

    if (qry.sub_cat_id !== undefined) {
      payload.sub_cat_id = qry.sub_cat_id;
    }

	  if (qry.diet_id !== undefined) {
		  payload.diet_id = qry.diet_id;
	  }

    if (Array.isArray(qry.country_id) && qry.country_id.length > 0) {
      payload.country_id = qry.country_id;
    }
  }

  // Now you can safely use the payload object

  await API.getProductsSelection(slug,1,limit,payload)
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        dispatch({
          type: actionTypes.PRODUCTS_SELECTION,
          allproducts: data.data.items,
          page: 1,
        });
        dispatch({
          type: actionTypes.PRODUCTS_SELECTION_FILTER,
          payload: {
            brand: getFilterBrands(data.data.brands),
            category: getFilterCategory(data.data.categories),
            sub_category: getFilterSubCategory(data.data.subCategories),
	          countries: getFilterCountry(data.data.countries),
	          dietary: getFilterDietary(data.data.dietary),
            page: 1,
            min: 0,
            max: 1000,
            sort: "a-z",
            promotion:false,
            priority: "1",
            oos: 0,
            brand_id: b?.length > 0 && b[0] != undefined ? b : 0,
            cat_id: c?.length > 0 ? c : 0,
            sub_cat_id: subCat?.length > 0 ? subCat : 0,
	          country_id: qry?.country_id,
	          diet_id: diet,
          },
        });
        dispatch({
          type: actionTypes.Loading_Disable,
        });
      }
    });
};

/**
 * Fetch all products with filters
 */
export const getAllProducts = async (dispatch, queryParams = {}) => {
	dispatch({type: actionTypes.FETCH_PRODUCTS_REQUEST});

	try {
		// Clean up query params - remove undefined/null values
		const cleanParams = Object.entries(queryParams).reduce((acc, [key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				// Convert arrays to comma-separated strings
				if (Array.isArray(value)) {
					acc[key] = value.join(',');
				} else {
					acc[key] = value;
				}
			}
			return acc;
		}, {});

		const response = await API.getProducts(cleanParams);
		const data = await response.json();

		if (response.ok) {
			dispatch({
				type: actionTypes.SET_PAGE_INFO,
				payload: data.pageInfo
			});
			dispatch({
				type: actionTypes.FETCH_PRODUCTS_SUCCESS,
				payload: {
					products: data.data || [],
					append: queryParams.append || false,
					pagination: {
						currentPage: data.pagination?.currentPage || queryParams.page || 1,
						totalPages: data.pagination?.totalPages || data.pagination?.total_pages || 1,
						totalItems: data.pagination?.total || data.pagination?.totalItems || 0,
						itemsPerPage: data.limit || queryParams.limit || 20,
						hasMore: data.pagination?.hasMore || false
					},
				}
			});
		} else {
			dispatch({
				type: actionTypes.FETCH_PRODUCTS_FAILURE,
				payload: data.message || 'Failed to fetch products'
			});
		}
	} catch (error) {
		console.error('getAllProducts error:', error);
		dispatch({
			type: actionTypes.FETCH_PRODUCTS_FAILURE,
			payload: error.message || 'Failed to fetch products'
		});
	}
};

export const getAllProductsFiltersOption = async (dispatch, queryParams = {}) => {
	try {
		// Clean up query params - remove undefined/null values
		const cleanParams = Object.entries(queryParams).reduce((acc, [key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				// Convert arrays to comma-separated strings
				if (Array.isArray(value)) {
					acc[key] = value.join(',');
				} else {
					acc[key] = value;
				}
			}
			return acc;
		}, {});

		const response = await API.getProductsFiltersOption(cleanParams);
		const data = await response.json();

		if (response.ok) {
			dispatch({
				type: actionTypes.FETCH_FILTERS_OPTION,
				payload: {
					categories: data.data.categories || [],
					subcategories: data.data?.subcategories || [],
					brands: data.data?.brands || [],
					dietary: data.data?.dietary || [],
					countries: data.data?.countries || [],
					priceRange: data.data?.priceRange || {min: 0, max: 1000}
				}
			});
		} else {
			// dispatch({
			// 	type: actionTypes.FETCH_PRODUCTS_FAILURE,
			// 	payload: data.message || 'Failed to fetch products'
			// });
		}
	} catch (error) {
		console.error('getAllProducts error:', error);
		// dispatch({
		// 	type: actionTypes.FETCH_PRODUCTS_FAILURE,
		// 	payload: error.message || 'Failed to fetch products'
		// });
	}
};

/**
 * Set multiple filters at once
 */
export const setFilters = (dispatch, filters) => {
	dispatch({
		type: actionTypes.SET_FILTERS,
		payload: filters
	});
};

/**
 * Set search query
 */
export const setSearch = (dispatch, query) => {
	dispatch({
		type: actionTypes.SET_SEARCH,
		payload: query
	});
};

/**
 * Set category
 */
export const setCategory = (dispatch, category) => {
	dispatch({
		type: actionTypes.SET_CATEGORY,
		payload: category
	});
};

/**
 * Set subcategory
 */
export const setSubCategory = (dispatch, subcategory) => {
	dispatch({
		type: actionTypes.SET_SUBCATEGORY,
		payload: subcategory
	});
};

/**
 * Set brand
 */
export const setBrand = (dispatch, brand) => {
	dispatch({
		type: actionTypes.SET_BRAND,
		payload: brand
	});
};

/**
 * Set country filter
 */
export const setCountry = (dispatch, country) => {
	dispatch({
		type: actionTypes.SET_COUNTRY,
		payload: country
	});
};

/**
 * Set dietary filter
 */
export const setDietary = (dispatch, dietary) => {
	dispatch({
		type: actionTypes.SET_DIETARY,
		payload: dietary
	});
};

/**
 * Set price range
 */
export const setPriceRange = (dispatch, min, max) => {
	dispatch({
		type: actionTypes.SET_PRICE_RANGE,
		payload: {min, max}
	});
};

/**
 * Set sort option
 */
export const setSort = (dispatch, sortBy) => {
	dispatch({
		type: actionTypes.SET_SORT,
		payload: sortBy
	});
};

/**
 * Set current page
 */
export const setPage = (dispatch, page) => {
	dispatch({
		type: actionTypes.SET_PAGE,
		payload: page
	});
};

/**
 * Reset page to 1 or specific page
 */
export const resetPages = (dispatch, page = 1) => {
	dispatch({
		type: actionTypes.RESET_PAGE,
		payload: page
	});
};

/**
 * Toggle filter panel visibility
 */
export const toggleFilters = (dispatch) => {
	dispatch({
		type: actionTypes.TOGGLE_FILTERS
	});
};

/**
 * Clear all filters
 */
export const clearFilters = (dispatch) => {
	dispatch({
		type: actionTypes.CLEAR_FILTERS
	});
};

/**
 * Reset filters to initial state
 */
export const resetFilter = (dispatch) => {
	dispatch({
		type: actionTypes.RESET_FILTERS
	});
};

/**
 * Set selected product
 */
export const setSelectedProduct = (dispatch, product) => {
	dispatch({
		type: actionTypes.SET_SELECTED_PRODUCT,
		payload: product
	});
};

/**
 * Clear selected product
 */
export const clearSelectedProduct = (dispatch) => {
	dispatch({
		type: actionTypes.CLEAR_SELECTED_PRODUCT
	});
};


